import React from "react";
import { CheckCircleFilled } from "@ant-design/icons";

/**
 * פס סטטוס עליון דק — לא כרטיס.
 */
export default function BookingStatusBar({
  title = "ההזמנה נשמרה בהצלחה",
  subtitle = "ההזמנה ממתינה לתשלום כדי להשלים את התהליך",
  packageId,
  ldsOrderId,
  className = "",
}) {
  return (
    <header className={`hr-order-status-strip ${className}`.trim()} aria-label="סטטוס הזמנה">
      <div className="hr-order-status-strip__main">
        <CheckCircleFilled className="hr-order-status-strip__icon" aria-hidden />
        <div className="hr-order-status-strip__copy">
          <h1 className="hr-order-status-strip__title">{title}</h1>
          <p className="hr-order-status-strip__subtitle">{subtitle}</p>
        </div>
      </div>
      <div className="hr-order-status-strip__progress" aria-hidden>
        <span className="hr-order-status-strip__progress-done">נשמר</span>
        <span className="hr-order-status-strip__progress-sep">·</span>
        <span className="hr-order-status-strip__progress-current">תשלום</span>
        <span className="hr-order-status-strip__progress-sep">·</span>
        <span className="hr-order-status-strip__progress-todo">אישור סופי</span>
      </div>
      <div className="hr-order-status-strip__meta">
        {packageId ? (
          <span className="hr-order-tertiary" translate="no">
            הזמנה {packageId}
          </span>
        ) : null}
        {packageId && ldsOrderId != null && String(ldsOrderId).trim() !== "" ? (
          <span className="hr-order-status-strip__meta-sep" aria-hidden>
            |
          </span>
        ) : null}
        {ldsOrderId != null && String(ldsOrderId).trim() !== "" ? (
          <span className="hr-order-tertiary" translate="no">
            LDS {ldsOrderId}
          </span>
        ) : null}
      </div>
    </header>
  );
}
